import React, { useState } from "react";
import "tailwindcss/tailwind.css";
import Sidebaradmin from "./Components/Sidebar";
import Navbaradmin from "./Components/navbar";
import { AiFillContacts, AiFillEye, AiFillDollarCircle, AiFillShopping, AiOutlineFall } from "react-icons/ai";
import NewUsers from "./Components/NewUsers";
import VisitorsAnalytics from "./Components/VisitorsAnalytics";
import ProfitOfThePeriod from "./Components/ProfitOfThePeriod";

const sampleUsers = [
  { name: 'John Doe', email: 'john.doe@example.com', joinedDate: '2024-09-10', plan: 'Pro', lastLogin: '2024-09-12', paymentMethod: 'Credit Card', subscriptionStatus: 'Active' },
  { name: 'Jane Smith', email: 'jane.smith@example.com', joinedDate: '2024-09-11', plan: 'Basic', lastLogin: '2024-09-10', paymentMethod: 'PayPal', subscriptionStatus: 'Inactive' },
  { name: 'Alice Johnson', email: 'alice.johnson@example.com', joinedDate: '2024-09-12', plan: 'Standard', lastLogin: '2024-09-12', paymentMethod: 'Credit Card', subscriptionStatus: 'Active' }
];

const refundReasons = [
  { user: 'John Doe', reason: 'Service Quality', amount: '$100' },
  { user: 'Jane Smith', reason: 'Billing Error', amount: '$150' },
  { user: 'Alice Johnson', reason: 'Other', amount: '$50' }
];

// Sample chat history data
const chatHistoryData = {
  'John Doe': [
    { user: 'Admin', message: 'Please review the latest refund requests.' },
    { user: 'John Doe', message: 'Can you provide an update?', photo: 'https://via.placeholder.com/50' },
  ],
  'Jane Smith': [
    { user: 'Jane Smith', message: 'I need help with my account.', photo: 'https://via.placeholder.com/50' },
    { user: 'Admin', message: 'Sure, I’m checking on that right now.' },
  ],
  'Alice Johnson': [
    { user: 'Alice Johnson', message: 'Thank you for the support!', photo: 'https://via.placeholder.com/50' },
    { user: 'Admin', message: 'You’re welcome!' },
  ]
};


export default function AdminPanel() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [newMessage, setNewMessage] = useState('');
  const [chatHistory, setChatHistory] = useState(chatHistoryData);

  const handleUserClick = (user) => {
    setSelectedUser(user);
  };

  const handleBackToUserList = () => {
    setSelectedUser(null);
  };

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      const updatedChatHistory = { ...chatHistory };
      updatedChatHistory[selectedUser].push({ user: 'Admin', message: newMessage });
      setChatHistory(updatedChatHistory);
      setNewMessage('');
    }
  };
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">
      <Sidebaradmin />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation Bar */}
        <Navbaradmin />

        {/* Main Content Area */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200 p-6">
          {/* Dashboard Overview */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
              <h3 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
                <AiFillEye className="text-blue-600" /> $3.456K
              </h3>
              <div className="mt-4">
                <h4 className="text-sm text-gray-600">Total View</h4>
                <div className="flex items-center gap-2 text-red-600 mt-1">
                  <h4 className="text-lg font-semibold">0.13</h4>
                  <AiOutlineFall />
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
              <h3 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
                <AiFillDollarCircle className="text-green-600" /> $45.2K
              </h3>
              <div className="mt-4">
                <h4 className="text-sm text-gray-600">Total Profit</h4>
                <div className="flex items-center gap-2 text-red-600 mt-1">
                  <h4 className="text-lg font-semibold">0.13</h4>
                  <AiOutlineFall />
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
              <h3 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
                <AiFillShopping className="text-yellow-600" /> 2,450
              </h3>
              <div className="mt-4">
                <h4 className="text-sm text-gray-600">Total Products</h4>
                <div className="flex items-center gap-2 text-red-600 mt-1">
                  <h4 className="text-lg font-semibold">0.13</h4>
                  <AiOutlineFall />
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
              <h3 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
                <AiFillContacts className="text-purple-600" /> 3,456
              </h3>
              <div className="mt-4">
                <h4 className="text-sm text-gray-600">Total Users</h4>
                <div className="flex items-center gap-2 text-red-600 mt-1">
                  <h4 className="text-lg font-semibold">0.13</h4>
                  <AiOutlineFall />
                </div>
              </div>
            </div>
          </div>

          {/* Charts and Analytics */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col">
              <VisitorsAnalytics />
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Profit of the Period</h3>
              <ProfitOfThePeriod />
            </div>
          </div>

          {/* New Users Section */}
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
            <NewUsers users={sampleUsers} />
          </div>

          {/* Additional Content Cards */}
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Additional Content</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-1">Active Users</h3>
                <p className="text-gray-600 text-sm">2,500</p>
              </div>
              <div className="bg-green-100 text-green-600 rounded-full p-2">
                <AiFillContacts className="text-2xl" />
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-1">Non-Subscribers</h3>
                <p className="text-gray-600 text-sm">350</p>
              </div>
              <div className="bg-red-100 text-red-600 rounded-full p-2">
                <AiFillEye className="text-2xl" />
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-1">Expired Subscriptions</h3>
                <p className="text-gray-600 text-sm">120</p>
              </div>
              <div className="bg-yellow-100 text-yellow-600 rounded-full p-2">
                <AiFillDollarCircle className="text-2xl" />
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-1">Pending Refunds</h3>
                <p className="text-gray-600 text-sm">$200</p>
              </div>
              <div className="bg-blue-100 text-blue-600 rounded-full p-2">
                <AiFillShopping className="text-2xl" />
              </div>
            </div>
          </div>

          {/* Refund Requests */}
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6 mt-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Refund Requests</h2>
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-200 text-gray-600">
                <tr>
                  <th className="py-2 px-4 border-b">User</th>
                  <th className="py-2 px-4 border-b">Reason</th>
                  <th className="py-2 px-4 border-b">Amount</th>
                </tr>
              </thead>
              <tbody>
                {refundReasons.map((refund, index) => (
                  <tr key={index}>
                    <td className="py-2 px-4 border-b">{refund.user}</td>
                    <td className="py-2 px-4 border-b">{refund.reason}</td>
                    <td className="py-2 px-4 border-b">{refund.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Chat Messages */}
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200 p-6">
          {/* Chat Section */}
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Chat Messages</h2>

            {selectedUser ? (
              <div className="flex flex-col h-full">
                {/* Chat header */}
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-semibold">{selectedUser}</h3>
                  <button
                    className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400 transition duration-200 ease-in-out"
                    onClick={handleBackToUserList}
                  >
                    Back to User List
                  </button>
                </div>

                {/* Chat History */}
                <div className="flex-1 overflow-y-auto bg-gray-50 p-4 rounded-lg mt-4 shadow-inner">
                  {chatHistory[selectedUser].map((chat, index) => (
                    <div
                      key={index}
                      className={`flex items-start mb-3 ${
                        chat.user === 'Admin' ? 'justify-end' : 'justify-start'
                      }`}
                    >
                      {chat.user !== 'Admin' && (
                        <img
                          src={chat.photo}
                          alt="user avatar"
                          className="w-10 h-10 rounded-full mr-2"
                        />
                      )}
                      <div
                        className={`max-w-xs p-4 rounded-lg text-white shadow-lg ${
                          chat.user === 'Admin'
                            ? 'bg-gradient-to-r from-green-400 to-green-600'
                            : 'bg-gradient-to-r from-blue-400 to-blue-600'
                        }`}
                      >
                        <p className="font-semibold text-sm">{chat.user}</p>
                        <p className="text-base">{chat.message}</p>
                      </div>
                      {chat.user === 'Admin' && (
                        <img
                          src="https://via.placeholder.com/50"
                          alt="admin avatar"
                          className="w-10 h-10 rounded-full ml-2"
                        />
                      )}
                    </div>
                  ))}
                </div>

                {/* Input and Send Button */}
                <div className="mt-4 flex items-center space-x-2">
                  <input
                    type="text"
                    className="w-full p-3 rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out"
                    placeholder="Type your message..."
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                  />
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-200 ease-in-out shadow-md"
                    onClick={handleSendMessage}
                  >
                    Send
                  </button>
                </div>
              </div>
            ) : (
              <div className="max-h-96 overflow-y-auto bg-gray-50 p-4 rounded-lg shadow-inner">
                {/* List of users with avatars */}
                {sampleUsers.map((user, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center bg-white p-4 mb-3 rounded-lg shadow-md hover:bg-gray-100 transition duration-200 ease-in-out cursor-pointer"
                    onClick={() => handleUserClick(user.name)}
                  >
                    <div className="flex items-center">
                      <img
                        src={user.photo}
                        alt="user avatar"
                        className="w-10 h-10 rounded-full mr-3"
                      />
                      <div>
                        <h3 className="text-xl font-bold text-gray-800">{user.name}</h3>
                        <p className="text-sm text-gray-600">{user.lastMessage}</p>
                      </div>
                    </div>
                    {user.unread && (
                      <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full shadow-sm">
                        Unread
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </main>
        </main>
      </div>
    </div>
  );
}
